import { Injectable } from '@angular/core';
import { map, Observable, of, Subject } from 'rxjs';
import { PageJsonResults } from '../../common/services/page/page-data.viewmodel';
import { PageService } from '../../common/services/page/page.service';
import { Bookmarks, MenuResponse, MenuResults, UpdateBookmarkRequest } from './menu.model';
import { ExperienceFragmentResponse } from '../../common/services/page/page-component-data.viewmodel';
import { BaseService } from '../../common/services/base.service';

@Injectable({
  providedIn: 'root',
})
export class MenuService {
  private menuSubject = new Subject<MenuResponse>();
  menuData$: Observable<MenuResponse> = this.menuSubject.asObservable();
  constructor(private pageService: PageService, private baseService: BaseService) {}

  setMenuData(menuData: MenuResponse) {
    this.menuSubject.next(menuData);
  }

  getMenuData(): Observable<MenuResponse> {
    return this.menuData$;
  }

  updateBookmark(appLinkDetails?: Bookmarks, bookmarkOperation?: string, parentMenuName?: string): Observable<any> {
    let apiUrl = `/v1/lpmi/portal/updateBookmark`;
    let request = this.updateBookmarkRequest(appLinkDetails, bookmarkOperation, parentMenuName);
    return this.baseService.post<any>(`${apiUrl}`, request, 'API').pipe(
      map((res: any) => {
        return res;
      })
    );
  }

  private updateBookmarkRequest(appLinkDetails?: Bookmarks, bookmarkOperation?: string, parentMenuName?: string) {
    let request = new UpdateBookmarkRequest();
    request.category = appLinkDetails.category;
    request.parentMenuName = parentMenuName;
    request.bookmarkOperation = bookmarkOperation;
    request.label = appLinkDetails.label;
    request.link = appLinkDetails.link;
    request.linkType = appLinkDetails.linkType;
    request.userDetails = this.pageService.getUserDetails();
    request.linkDescription = appLinkDetails?.linkDescription || '';
    request.name = appLinkDetails.name;
    request.subCategory = appLinkDetails.subCategory;
    return request;
  }
}
